import { createFileRoute } from "@tanstack/react-router";
import { EreborBanking } from "@/components/EreborBanking";

function RouteComponent() {
  return <EreborBanking />;
}

export const Route = createFileRoute("/_authenticated/erebor-banking/")({
  component: RouteComponent,
  staticData: { page: "banking" },
});
